import { NgModule } from '@angular/core';
import { Store, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { GenesysCloudUserEffects } from './effects/user.effects';
import { featureKey, genesysCloudUsersReducer } from './reducers/user.reducers';
import { initializeModule } from './actions/user.actions';
import { BcConfigService } from 'common/config/provider';

@NgModule({
  imports: [
    StoreModule.forFeature(featureKey, genesysCloudUsersReducer),
    EffectsModule.forFeature([
      GenesysCloudUserEffects
    ])
  ]
})
export class GenesysCloudUsersModule {
  constructor(readonly store: Store, readonly configService: BcConfigService) {
    if (configService.isGenesysConversationEnabled()) {
      store.dispatch(initializeModule());
    }
  }
}
